import { Interval } from 'date-fns';
import { DateTimeHelper } from '../../features/calendar/util/date-time-helper';

export function combineMaps<K, V>(map1: Map<K, V[]>, map2: Map<K, V[]>): Map<K, V[]> {
  const mergedMap = new Map<K, V[]>(map1); // Copy map1

  map2.forEach((value, key) => {
    if (mergedMap.has(key)) {
      let existing = mergedMap.get(key);
      existing = existing!.concat(value);
      // If key exists in both maps, concatenate arrays
      mergedMap.set(key, existing);
    } else {
      // If key exists only in map2, add it to mergedMap
      mergedMap.set(key, value);
    }
  });

  return mergedMap;
}

/**
 * Limit the range and fill missing days with 0.
 * @param dateMap
 * @param limitRange
 * @return A new map including date fillers.
 */
export function fillDateMap(
  dateMap: Map<string, number>,
  limitRange: Interval | null = null,
): Map<string, number> {
  if (limitRange === null) {
    const sortedArray = Array.from(dateMap.keys()).sort();
    limitRange = {
      start: sortedArray[0],
      end: sortedArray.pop()!,
    };
  }
  const updatedMap = new Map<string, number>();
  DateTimeHelper.eachDayOfInterval(limitRange.start as Date, limitRange.end as Date).forEach(
    (date) => {
      const curDateString = DateTimeHelper.format(date);
      if (dateMap.has(curDateString)) {
        updatedMap.set(curDateString, dateMap.get(curDateString)!);
        return;
      }

      updatedMap.set(curDateString, 0);
    },
  );
  return updatedMap;
}

export function mapToArray<T, U extends readonly unknown[]>(
  map: Map<T, U>,
  toFlat = false,
): U[] | U[number][] {
  const values = Array.from(map.values());
  return toFlat ? values.flat() : values;
}
